/**
 * Text Only Cards block script.
 *
 * Stagger fade-up across the cards on scroll-into-view. Cards already have
 * an offset shadow rectangle; the entrance gives them a brief moment of
 * arrival rather than appearing fully formed.
 */

import { revealStagger, motionTokens } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-text-only-cards').forEach((section) => {
		const grid = section.querySelector('.container > .grid');
		if (!grid) return;

		revealStagger(grid, {
			stagger: motionTokens.stagger,
			duration: motionTokens.durMd,
		});
	});
});
